import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PhoneValidator } from '@iqd/shared-utils';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-contact-details-modal',
  templateUrl: './contact-details-modal.component.html',
  styleUrls: ['./contact-details-modal.component.scss'],
})
export class ContactDetailsModalComponent {
  form: FormGroup;

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder) {
    this.createForm();
  }

  private createForm() {
    this.form = this.fb.group({
      phoneNumber: [null, [PhoneValidator.validCountryPhone('GB')]],
      email: [null, [Validators.required, Validators.email]],
    });
  }

  onSubmit() {
    this.activeModal.close(this.form.value);
  }
}
